import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "components/elements";

type VendorAddedProps = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

export const VendorAddedModal = ({ isOpen, setIsOpen }: VendorAddedProps) => {
    return (
        <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 z-50 bg-[#424242]/75" />
                <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-xs -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-lg shadow-lg">
                    {/* Top icon section */}
                    <div className="relative flex h-[170px] items-center justify-center bg-[#DFF1FA] p-2">
                        <CheckIcon className="h-9 w-9 rounded bg-white px-1 py-2 text-[#09244B]" />
                        <Dialog.Close asChild>
                            <button className="absolute right-2 top-2 rounded-sm  text-gray-500 hover:text-gray-800">
                                <XMarkIcon className="h-5 w-5" />
                            </button>
                        </Dialog.Close>
                    </div>

                    <div className="space-y-4 bg-white p-4">
                        <div className="flex  flex-col items-start">
                            <div className="text-sm text-gray-600">
                                Thank you for your submission. This vendor will be reviewed and
                                added upon approval.
                            </div>
                        </div>
                        <div className="flex justify-start">
                            <Dialog.Close asChild>
                                <Button variant="primary" onClick={() => setIsOpen(false)}>
                                    Okay
                                </Button>
                            </Dialog.Close>
                        </div>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
